export const RoutePaths = {
  landing: "/",
  calculator: "/calculator",
};

export const MAIN_LANDING_PAGE = "https://herdplan.co.uk/";
export const HERDPLAN_APP = "https://app.herdplan.co.uk/";